/* Organique Kuwait – round 6 additions (kept separate from organique.js / organique-r5.js) */
(function () {
  'use strict';
  var d = document;
  var html = d.documentElement;
  var T = window.OrgT || {};
  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  function mq(q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; }

  /* ---------- F1: hide the WhatsApp button while a drawer / dialog is open (fallback for browsers without :has()) ---------- */
  var hasHas = false;
  try { hasHas = !!(window.CSS && CSS.supports && CSS.supports('selector(:has(a))')); } catch (x) { hasHas = false; }
  if (!hasHas && 'MutationObserver' in window) {
    var overlaySel = 'dialog[open], theme-drawer[open], details.menu-open';
    var syncOverlay = function () { html.classList.toggle('org-overlay-open', !!d.querySelector(overlaySel)); };
    new MutationObserver(syncOverlay).observe(d.body, { subtree: true, attributes: true, attributeFilter: ['open', 'class'] });
    syncOverlay();
  }

  /* ---------- F3: phones – show the sticky add-to-cart bar whenever the main button is not fully visible ----------
     (fully visible = inside the top of the screen and the screen height minus 100 px). Hidden at the page bottom. */
  (function () {
    var sticky = d.querySelector('sticky-add-to-cart');
    var bar = sticky && sticky.querySelector('.sticky-add-to-cart__bar');
    if (!bar) return;
    var phone = mq('(max-width: 749px)');
    var footer = d.querySelector('footer');
    function mainButton() {
      var sec = sticky.closest('.shopify-section') || d;
      var form = sec.querySelector('product-form-component[data-product-id="' + sticky.getAttribute('data-product-id') + '"]');
      return form && form.querySelector('[ref="addToCartButton"]');
    }
    function update() {
      if (!phone.matches) { if (bar.hasAttribute('data-org-show')) bar.removeAttribute('data-org-show'); return; }
      var btn = mainButton();
      if (!btn) return;
      var vh = window.innerHeight || html.clientHeight;
      var r = btn.getBoundingClientRect();
      var fullyVisible = r.top >= 0 && r.bottom <= vh - 100;
      var atBottom = footer ? footer.getBoundingClientRect().top < vh : false;
      var chat = window.customElements && customElements.get('shopify-chat') && d.querySelector('shopify-chat');
      var show = r.height > 0 && !fullyVisible && !atBottom && !chat;
      var val = show ? 'true' : 'false';
      if (bar.getAttribute('data-org-show') !== val) bar.setAttribute('data-org-show', val);
    }
    var queued = false;
    function queue() {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; update(); }, 50);
    }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    window.addEventListener('load', update);
    if (phone.addEventListener) phone.addEventListener('change', update); else if (phone.addListener) phone.addListener(update);
    update();
    setTimeout(update, 600);
  })();

  /* ---------- F4: language switch keeps the current search terms, filters, sort and page ----------
     The links are built on the server; this refreshes them from the address bar at the moment they are used
     (filters on the search page change the address without reloading). */
  function refreshLangLink(a) {
    var href = a.getAttribute('href');
    if (!href) return;
    var base = href.split('#')[0].split('?')[0];
    var want = base + window.location.search;
    if (href !== want) a.setAttribute('href', want);
  }
  function onLangUse(e) {
    var t = e.target;
    var a = t && t.closest ? t.closest('.org-lang a[href], #OrgLangbar a[href]') : null;
    if (a) refreshLangLink(a);
  }
  ['pointerdown', 'mousedown', 'touchstart', 'focusin', 'click', 'auxclick', 'contextmenu'].forEach(function (ev) {
    d.addEventListener(ev, onLangUse, { capture: true, passive: true });
  });
  each(d.querySelectorAll('.org-lang a[href], #OrgLangbar a[href]'), refreshLangLink);

  /* ---------- F12: phones – collection intro clamped to two lines with a "Read more" toggle ---------- */
  (function () {
    var phone = mq('(max-width: 749px)');
    each(d.querySelectorAll('.org-coll__desc'), function (desc, i) {
      if (desc.querySelector('.org-readmore')) return;
      if (!desc.id) desc.id = 'OrgCollDesc-' + i;
      var btn = d.createElement('button');
      btn.type = 'button';
      btn.className = 'org-readmore';
      btn.textContent = T.readMore || 'Read more';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', desc.id);
      btn.hidden = true;
      desc.appendChild(btn);
      function fit() {
        if (desc.classList.contains('is-open')) { btn.hidden = !phone.matches; return; }
        btn.hidden = true;
        btn.hidden = !(phone.matches && desc.scrollHeight > desc.clientHeight + 2);
      }
      btn.addEventListener('click', function () {
        var open = !desc.classList.contains('is-open');
        desc.classList.toggle('is-open', open);
        btn.textContent = open ? (T.readLess || 'Show less') : (T.readMore || 'Read more');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!open) fit();
      });
      fit();
      window.addEventListener('resize', fit);
      window.addEventListener('load', fit);
    });
  })();
})();
